const initialState = {
  data: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    users: []
  },
  isLoading: false,
  hasErrored: false,
  hasErrored_USER:false,
  isSubmiting: false,
  isSubmited: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case '[USERS_CONFIG] HAS_ERRORED':
      return { ...initialState, data: initialState.data, isLoading: false,hasErrored: true };
    case '[USERS_CONFIG] HAS_ERRORED_USER':
      return {  isLoading: false,hasErrored_USER: true };
    case '[USERS_CONFIG] IS_LOADING':
      return { ...initialState, data: initialState.data, isLoading: true };
    case '[USERS_CONFIG] FETCH_SUCCESS':
      return {...state, hasErrored: false, isLoading: false, data: action.data};

    default:
      return state;
  }
};
